// import React, { createContext, useContext, useState } from 'react';


// let userInfo = !localStorage.user_info ? {
//   Email: '',
//   FullName: '',
//   Role: '',
//   module: '',
//   permissions: {
//     CanRead: false,
//     CanView: false,
//     CanCopy: false,
//     CanDelete: false,
//     CanEdit: false,
//     CanCreate: false
//   }
// } : JSON.parse(localStorage.user_info);

// // let initialAuthData = !localStorage.auth_data ? {
// //   homeAccountId: '',
// //   environment: '',
// //   tenantId: '',
// //   username: '',
// //   localAccountId: '',
// //   name: '',
// //   authorityType: '',
// //   tenantProfiles: {},
// //   idToken: '',
// //   accessToken: '',
// // } : JSON.parse(localStorage.auth_data);

// let initialAuthData = !localStorage.auth_data ? {
//   homeAccountId: '',
//   environment: '',
//   tenantId: '',
//   username: '',
//   localAccountId: '',
//   name: '',
//   authorityType: '',
//   idToken: '',
//   accessToken: '',
// } : JSON.parse(localStorage.auth_data);


// // let initialAuthData =  {
// //   homeAccountId: '',
// //   environment: '',
// //   tenantId: '',
// //   username: '',
// //   localAccountId: '',
// //   name: '',
// //   authorityType: '',
// //   tenantProfiles: {},
// //   idToken: '',
// //   accessToken: '',
// // } 

// type AppContextType = {
//   appData: {
//     isFormChanged: boolean;
//     showUnSavedModal: boolean;
//     url: string;
//   };
//   userData: {
//     email: string;
//     name: string;
//     role: string;
//     module: string;
//     permissions: {
//       CanRead: boolean;
//       CanView: boolean;
//       CanCopy: boolean;
//       CanDelete: boolean;
//       CanEdit: boolean;
//       CanCreate: boolean;
//     };
//   };
//   authData: typeof initialAuthData;

//   updateAppData: (newData: { isFormChanged?: boolean, showUnSavedModal?: boolean, url?: string }) => void;
//   updateUserData: (newData: {
//     email: string, name: string, role: string, module: string, permissions: {
//       CanRead: boolean,
//       CanView: boolean,
//       CanCopy: boolean,
//       CanDelete: boolean,
//       CanEdit: boolean,
//       CanCreate: boolean
//     }
//   }) => void;
//   updateAuthData: (newData: Partial<typeof initialAuthData>) => void;
// };

// const AppContext = createContext<AppContextType | undefined>(undefined);

// type AppProviderProps = {
//   children: React.ReactNode;
// };




// export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
//   // Initialize state from localStorage or defaults
//   const [appData, setAppData] = useState({
//     isFormChanged: false,
//     showUnSavedModal: false,
//     url: ''
//   });

//   const [userData, setUserData] = useState<AppContextType['userData']>(() => {
//     return localStorage.user_info ? JSON.parse(localStorage.user_info) : {
//       Email: '',
//       FullName: '',
//       Role: '',
//       module: '',
//       permissions: {
//         CanRead: false,
//         CanView: false,
//         CanCopy: false,
//         CanDelete: false,
//         CanEdit: false,
//         CanCreate: false
//       }
//     };
//   });

//   const [authData, setAuthData] = useState<typeof initialAuthData>(() => {
//     return localStorage.auth_data ? JSON.parse(localStorage.auth_data) : initialAuthData;
//   });

//   const updateAppData = React.useCallback((newData: { isFormChanged?: boolean, showUnSavedModal?: boolean, url?: string }) => {
//     setAppData(prev => ({ ...prev, ...newData }));
//   }, []);

//   const updateUserData = React.useCallback((newData: Partial<AppContextType['userData']>) => {
//     setUserData(prev => {
//       const updated = { ...prev, ...newData };
//       localStorage.setItem('user_info', JSON.stringify(updated));
//       return updated;
//     });
//   }, []);

//   const updateAuthData = React.useCallback((newData: Partial<typeof initialAuthData>) => {
//       // @ts-ignore
//     setAuthData(prev => {
//       const updated = { ...prev, ...newData };
//       localStorage.setItem('auth_data', JSON.stringify(updated));
//       return updated;
//     });
//   }, []);

//   // Memoize the context value to prevent unnecessary re-renders
//   const value = React.useMemo(() => ({
//     appData,
//     userData,
//     authData,
//     updateAppData,
//     updateUserData,
//     updateAuthData
//   }), [appData, userData, authData, updateAppData, updateUserData, updateAuthData]);

//   return (
//     <AppContext.Provider value={value}>
//       {children}
//     </AppContext.Provider>
//   );
// };

// export const useAppContext = () => {
//   const context = useContext(AppContext);
//   if (context === undefined) {
//     throw new Error('useAppContext must be used within an AppProvider');
//   }
//   return context;
// };


import React, { createContext, useContext, useState, useCallback } from 'react';

const defaultPermissions = {
  CanRead: false,
  CanView: false,
  CanCopy: false,
  CanDelete: false,
  CanEdit: false,
  CanCreate: false,
};

const userInfo = localStorage.user_info
  ? {
      email: '',
      name: '',
      role: '',
      module: '',
      permissions: defaultPermissions,
      ...JSON.parse(localStorage.user_info),
    }
  : {
      email: '',
      name: '',
      role: '',
      module: '',
      permissions: defaultPermissions,
    };

const initialAuthData = localStorage.auth_data
  ? JSON.parse(localStorage.auth_data)
  : {
      homeAccountId: '',
      environment: '',
      tenantId: '',
      username: '',
      localAccountId: '',
      name: '',
      authorityType: '',
      idToken: '',
      accessToken: '',
    };

// Define error type
type ErrorState = {
  isError: boolean;
  message: string;
};

type AppContextType = {
  appData: {
    isFormChanged: boolean;
    showUnSavedModal: boolean;
    url: string;
  };
  userData: typeof userInfo;
  authData: typeof initialAuthData;
  error: ErrorState;
  // @ts-ignore
  updateAppData: (newData: Partial<typeof appData>) => void;
  updateUserData: (newData: Partial<typeof userInfo>) => void;
  updateAuthData: (newData: Partial<typeof initialAuthData>) => void;
  updateError: (newError: Partial<ErrorState>) => void;
};

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [appData, setAppData] = useState({
    isFormChanged: false,
    showUnSavedModal: false,
    url: '',
  });

  const [userData, setUserData] = useState(userInfo);
  const [authData, setAuthData] = useState(initialAuthData);
  const [error, setError] = useState<ErrorState>({ isError: false, message: '' });

  const updateAppData = useCallback((newData: Partial<typeof appData>) => {
    setAppData(prev => ({ ...prev, ...newData }));
  }, []);

  const updateUserData = useCallback((newData: Partial<typeof userInfo>) => {
    const updated = { ...userData, ...newData };
    setUserData(updated);
    localStorage.setItem('user_info', JSON.stringify(updated));
  }, [userData]);

  const updateAuthData = useCallback((newData: Partial<typeof initialAuthData>) => {
    const updated = { ...authData, ...newData };
    setAuthData(updated);
    localStorage.setItem('auth_data', JSON.stringify(updated));
  }, [authData]);

  const updateError = useCallback((newError: Partial<ErrorState>) => {
    setError(prev => ({ ...prev, ...newError }));
  }, []);

  return (
    <AppContext.Provider
      value={{
        appData,
        userData,
        authData,
        error,
        updateAppData,
        updateUserData,
        updateAuthData,
        updateError,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
